import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import CMSContent from '../CMSContent/index.jsx';
import StateSelector from '../Forms/StateSelector/index.jsx';


/**
 * A helper component to save my fingers from typing.
 */
function FieldColumn(props) {
  return (
    <Col md="6" lg="12" xl="6">
      {props.children}
    </Col>
  );
}


class CheckoutBillingFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      country: undefined,
      state: undefined
    };

    this.checkoutForm = undefined;

    this.onChangeCountry = this.onChangeCountry.bind(this);
    this.onChangeState = this.onChangeState.bind(this);
  }

  onChangeCountry(event) {
    this.setState({ country: event.target.value });

    if (this.checkoutForm) {
      this.checkoutForm.trigger('update');
    }
  }

  onChangeState(event) {
    this.setState({ state: event.target.value });
  }

  getCountryOptions() {
    var result = [];

    result.push(<option key="empty" value="">Select a country/region...</option>);
    if (this.props.countries) {
      for (var i = 0; i < this.props.countries.length; i++) {
        var country = this.props.countries[i];

        result.push(<option key={country.key} value={country.key}>{country.name}</option>);
      }
    } else {
      // ensure we add the default value to the field while we're loading the
      // countries
      var country = this.props.fields.billing_country;
      result.push(<option key={country} value={country}>{country}</option>);
    }


    return result;
  }

  componentDidMount() {
    this.checkoutForm = jQuery('form.checkout');
  }

  render() {
    var firstname = this.props.fields.billing_first_name;
    var lastname = this.props.fields.billing_last_name;
    var company = this.props.fields.billing_company;
    var email = this.props.fields.billing_email;
    var country = this.props.fields.billing_country;
    if (this.state.country) {
      country = this.state.country;
    }
    var state = this.props.fields.billing_state;
    if (this.state.state) {
      state = this.state.state;
    }
    var address1 = this.props.fields.billing_address_1;
    var address2 = this.props.fields.billing_address_2;
    var city = this.props.fields.billing_city;
    var postcode = this.props.fields.billing_postcode;
    var phone = this.props.fields.billing_phone;

    var username = this.props.fields.account_username;
    var password = this.props.fields.account_password;
    var cs_step = this.props.csStep;

    var fields = [];
    fields.push(
      <Row key="name" className="mt-3">
        <FieldColumn>
          <Form.Group>
            <Form.Label htmlFor="billing_first_name">
              First name
            </Form.Label>
            <Form.Control
              name="billing_first_name"
              type="text"
              id="billing_first_name"
              defaultValue={firstname}
              required
              autoComplete="given-name"
            />
          </Form.Group>
        </FieldColumn>
        <FieldColumn>
          <Form.Group>
            <Form.Label htmlFor="billing_last_name">
              Last name
            </Form.Label>
            <Form.Control
              name="billing_last_name"
              type="text"
              id="billing_last_name"
              defaultValue={lastname}
              required
              autoComplete="family-name"
            />
          </Form.Group>
        </FieldColumn>
      </Row>
    );
    fields.push(
      <Row key="phcom">
        <FieldColumn>
          <Form.Group>
            <Form.Label htmlFor="billing_phone">
              Phone Number
            </Form.Label>
            <Form.Control
                name="billing_phone"
                type="tel"
                id="billing_phone"
                defaultValue={phone}
                required
                autoComplete="tel"
            />
            <div className="error text-danger" style={{display:'none'}}></div>
          </Form.Group>
        </FieldColumn>
        <FieldColumn>
          <Form.Group>
            <Form.Label htmlFor="billingCompany">
              Company name (optional)
            </Form.Label>
            <Form.Control
              name="billingCompany"
              type="text"
              id="billingCompany"
              defaultValue={company}
              autoComplete="organization"
            />
          </Form.Group>
        </FieldColumn>
      </Row>
    );
    fields.push(
      <Row key="country-state">
        <FieldColumn>
          <Form.Group>
            <Form.Label htmlFor="billing_country">
              Country / Region
            </Form.Label>
            <Form.Control
              as="select"
              name="billing_country"
              id="billing_country"
              custom
              required
              value={country}
              onChange={this.onChangeCountry}
              autoComplete="country"
            >
              {this.getCountryOptions()}
            </Form.Control>
          </Form.Group>
        </FieldColumn>
        <FieldColumn>
          <StateSelector
            state={state}
            onChange={this.onChangeState}
            country={country}
            countries={this.props.countries}
            id="billing_state"
            name="billing_state"
          />
        </FieldColumn>
      </Row>
    );
    fields.push(
      <Row key="address" className="align-items-end">
        <FieldColumn>
          <Form.Group>
            <Form.Label htmlFor="billing_address_1">
              Street address
            </Form.Label>
            <Form.Control
              type="text"
              name="billing_address_1"
              id="billing_address_1"
              placeholder="House number and street address"
              defaultValue={address1}
              required
              autoComplete="address-line1"
            />
          </Form.Group>
        </FieldColumn>
        <FieldColumn>
          <Form.Group>
            <Form.Label htmlFor="billing_address_2" className="sr-only">
              Apartment, suite, unit, etc. (Optional)
            </Form.Label>
            <Form.Control
              type="text"
              name="billing_address_2"
              id="billing_address_2"
              defaultValue={address2}
              autoComplete="address-line2"
            />
          </Form.Group>
        </FieldColumn>
      </Row>
    );
    fields.push(
      <Row key="city-postcode">
        <FieldColumn>
          <Form.Group>
            <Form.Label htmlFor="billing_city">
              Town / City
            </Form.Label>
            <Form.Control
              type="text"
              name="billing_city"
              id="billing_city"
              defaultValue={city}
              required
              autocompplete="address-level2"
            />
          </Form.Group>
        </FieldColumn>
        <FieldColumn>
          <Form.Group>
            <Form.Label htmlFor="billing_postcode">
              Postcode / Zip
            </Form.Label>
            <Form.Control
              type="text"
              name="billing_postcode"
              id="billing_postcode"
              defaultValue={postcode}
              required
              autoComplete="postal-code"
            />
          </Form.Group>
        </FieldColumn>
      </Row>
    );

    if (! this.props.isUser) {
      fields.push(
        <Row key="account">
          <FieldColumn>
            <Form.Group>
              <Form.Label htmlFor="account_username">
                Collective Shift Username
              </Form.Label>
              <Form.Control
                type="text"
                name="account_username"
                id="account_username"
                defaultValue={username}
                required
              />
            </Form.Group>
          </FieldColumn>
          <FieldColumn>
            <Form.Group>
              <Form.Label htmlFor="account_password">
                Collective Shift Password
              </Form.Label>
              <Form.Control
                type="password"
                name="account_password"
                id="account_password"
                defaultValue={password}
                required
              />
            </Form.Group>
          </FieldColumn>
        </Row>
      );

    }

    
    return (
        <React.Fragment>
          <CMSContent>
            <span className="cs-step">{cs_step}</span>
            <h3 className="d-inline-flex mx-2">Enter your information</h3>
          </CMSContent>
          {fields}
          <input type="hidden" name="phone_valid" value=""/>
          <input type="hidden" name="billing_email" value={email}/>
        </React.Fragment>
    );
  }
}


export default CheckoutBillingFields;

